// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
import moment from 'moment';
// Styles
import Icon from '../../../../common/Icon'
import theme from '../../../../common/theme'
import { get } from 'lodash'
import { getBabysittingModeFrom } from '../../../../common/BabysittingModes'
import { getStatusFrom, isActive, isArchived } from '../../../../common/Record'

const WelcomePageRecordContainer = styled.div`

  .record {
    display: flex;
    height: 35px;
    margin-bottom: 5px;
    justify-content: space-between;
    align-items: center;
    background-color: ${ theme.palette.light_grey };
    &.active {
      cursor: pointer;
      &:hover {
        background-color: ${ theme.palette.grey };
      }
    }
  }

  .record-archived {
    background-color: ${ theme.palette.grey };
  }

  .first-name {
    width: 70px;
    padding-left: 20px;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;
    text-transform: lowercase;
  }
  .first-name::first-letter {
    text-transform: uppercase;
    font-weight: bold;
  }

  .babysitting-mode {
    width: 70px;
    font-size: 12px;
    line-height: 14px;
  }

  .status {
    min-width: 130px;
    padding-right: 5px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-decoration: underline;
  }

  .additional-action-record {
    margin: 10px 10px 10px 0px;
    font-size: 14px;
    text-align: right;
    line-height: 16px;
    text-decoration-line: underline;
    cursor: pointer;
  }

`

export default function WelcomePageRecord({
                                            record,
                                            actionRecord, babysittingModes,
                                            additionalActionLabel, additionalActionRecord,
                                            isChildActive,
                                            ...props
                                          }) {

  const isRecordActive = isActive(record) && (record.child && isChildActive(record.child.id))
    || (record.temporaryRightDate && moment().isBefore(record.temporaryRightDate))

  const recordClassName = 'record' + (isArchived(record) ? ' record-archived' : '') + (isRecordActive ? ' active' : '')

  return (

    <WelcomePageRecordContainer>

      <div className={ recordClassName } onClick={ isRecordActive ? actionRecord : null }>

        <div className="first-name">{ get(record, 'child.firstName', 'Non défini') }</div>

        <div
          className="babysitting-mode">{ getBabysittingModeFrom(babysittingModes, record.babysittingMode, 'name') || 'Non défini' }</div>

        <div className="status">
          { getStatusFrom(record).beneficiaryWelcomePageRecordLabel(isRecordActive) }
          { isRecordActive && actionRecord && <Icon name="chevron_right"/> }
        </div>

      </div>
      {
        additionalActionRecord && <div className=" additional-action-record" onClick={ additionalActionRecord }>
          { additionalActionLabel }
        </div>
      }
    </WelcomePageRecordContainer>

  )

}
